<template>
	<div class="button" @click.stop="$emit('click', $event)">
		<div class="button__label" v-if="label">{{ label }}</div>
	</div>
</template>

<script>
	export default {
		props: ['label', 'icon']
	}
</script>

<style>
	.button {
		cursor: pointer;
		height: 40px;
		line-height: 40px;
		padding: 0 40px 0 40px;
		background-color: #61ce70;
		color: white;
		border-radius: 20px;
	}
</style>